import React, { useContext } from 'react'
import { useParams, useHistory,useLocation } from 'react-router-dom'
import { PaystackConsumer } from 'react-paystack'
import farmerContext from "../../../context/farmer/farmerContext"
import { useAlert } from "react-alert"


const PayBalance = ({}) => {
    const FarmerContext = useContext(farmerContext);
    const { log_farmer_equipment_request } = FarmerContext;
    const alert = useAlert()
    const { query } = useLocation()
    const { init,bal,price,operator_charge } = query
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const history = useHistory();
    const config = {
        email: userInfo.email,
        amount: bal * 100,
        publicKey: 'pk_test_bf5cd1ee94c0c13b38631acc24c647d9dc1f0b1a',
    };

    // you can call this function anything
    const handleSuccess = (reference) => {
        // Implementation for whatever you want to do with reference and after success call.
        log_farmer_equipment_request(reference.reference)
        if (reference.status === "success"){
            alert.show(
                "Service Balance Paid Successful"
            )
            history.push("/farmer/farm/equipment/view")
        }else{
            alert.show(
                "Payments failed, Try again"
            )
        }
        
    };

    // you can call this function anything
    const handleClose = () => {
        console.log("closed")
        // implementation for  whatever you want to do when the Paystack dialog closed.
    }

    const componentProps = {
        ...config,
        text: 'Starting Payment',
        onSuccess: (reference) => handleSuccess(reference),
        onClose: handleClose
    };

    const viewServices = () => {
        history.push(`/farmer/farm/equipment`)
    }

    return (
        <div className="content-wrapper">
            <div className="container-fluid">
            <div class="card p-3">
                <h6>Make Balance Payment</h6>
                <div class="card-body d-flex flex-column h-100">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0"><strong>To be Payed By</strong></p>
                        <p class="mb-0"><strong>{userInfo.first_name + " " + userInfo.last_name}</strong></p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0">Caution fee</p>
                        <p class="mb-0">₦{Number(parseFloat(operator_charge.caution_fee)).toLocaleString()}</p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0">Operator fee</p>
                        <p class="mb-0">₦{Number(parseFloat(operator_charge.operator_fee)).toLocaleString()}</p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0">Initial Deposit</p>
                        <p class="mb-0">₦{Number(parseFloat(init)).toLocaleString()}</p>
                    </div>
                    <div class="py-3">
                        <hr></hr>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0">Balance</p>
                        <p class="mb-0">₦{Number(parseFloat(bal)).toLocaleString()}</p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <p class="mb-0">Grand total</p>
                        <p class="mb-0">₦{Number(parseFloat(price)).toLocaleString()}</p>
                    </div>
                    <div class="d-flex justify-content-between align-items-center text-dark-green">
                        <h5 class="text-dark-green">Total</h5>
                        <h5 class="make-bold text-dark-green">₦{Number(parseFloat(bal)).toLocaleString()}</h5>
                    </div>
                    <div class="mt-2">
                        <PaystackConsumer {...componentProps} >
                            {({ initializePayment }) => <button type='submit' className="btn btn-gravity-secondary text-white make-medium btn-block" onClick={() => initializePayment(handleSuccess, handleClose)}>Pay ₦{Number(parseFloat(bal)).toLocaleString()}</button>}
                        </PaystackConsumer>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PayBalance
